<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/tatApp/select"
      :model="formModel"
      @openAddDialog="changeInfo"
      :submitData="submitData"
      addShowPower="/tatApp/add"
      :submitService="submitService"
      @success="onSuccess"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
      <el-form-item label="版本号">
        <el-input
          type="text"
          maxlength="20"
          placeholder="请输入版本号"
          v-model="formModel.versionNum"
        ></el-input>
      </el-form-item>
      <el-form-item label="操作系统">
        <el-select v-model="formModel.os">
          <el-option
            v-for="item in osList"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getPage"
      class="appArea"
    >
      <el-table-column
        prop="tatName"
        label="应用名称"
        min-width="200"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div class="flex-row vertical-stretch flow-center">
            <el-image :src="scope.row.iconUrl" fit="cover" class="appIcon">
              <div slot="error" class="image-slot">
                <el-image
                  :src="
                    require('../../../assets/images/' +
                      (scope.row.os == 1 ? 'IOS' : 'Android') +
                      '.jpg')
                  "
                  fit="cover"
                ></el-image>
              </div>
            </el-image>
            <div
              class="flex-col flow-center"
              style="align-items: flex-start; min-width: 100px"
            >
              <p class="appName ellipsis">{{ scope.row.tatName }}</p>
              <p class="appType">{{ scope.row.os == 1 ? "IOS" : "Android" }}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="versionNum"
        label="版本"
        min-width="130"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p v-if="scope.row.versionNum || scope.row.build">
            {{ scope.row.versionNum }}
            {{ scope.row.build ? `（${scope.row.build}）` : scope.row.build }}
          </p>
          <p v-else>暂无</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="forceUpdate"
        label="更新机制"
        min-width="100"
        :formatter="formatTranTypee"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="editTime"
        label="更新时间"
        min-width="130"
        :formatter="formatNull"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tatSimpleName"
        label="操作"
        min-width="100"
        show-overflow-tooltip
        v-if="hasPerm('/tatApp/detail')"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import SelectOrgans from "components/business/SelectOrgans";

import privateKey from "service/constant/privateKey";
import Server from "common/conf/Server";
import OrganService from "service/OrganService";
import APPService from "service/APPService";
import forceUpdatesTypes from "service/constant/forceUpdatesTypes";
import Regs from "common/conf/Regs";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import StorageService from "store/interfaces";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "appareamanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectOrgans,
  },
  data() {
    return {
      commonUrl: "8883/tatApp/download/",
      uploadUrl: Server[process.env.NODE_ENV],
      formModel: {
        versionNum: "",
        os: "",
        status: "",
        tatSimpleId: "",
      },
      allTat: [
        {
          id: "",
          simpleName: "全部",
        },
      ],
      all: [
        {
          id: "",
          label: "全部",
        },
      ],
      oss: [
        {
          id: "0",
          label: "安卓",
        },
        {
          id: "1",
          label: "苹果",
        },
      ],
      status: [
        {
          id: "0",
          label: "禁用",
        },
        {
          id: "1",
          label: "启用",
        },
      ],
      tableData: [],
      page: {},
      submitService: APPService.list,
      formDialogTitle: "",
      dialogModel: {
        versionNum: "",
        os: "",
        status: "1",
        forceUpdate: "",
        versionDes: "",
        file: "",
        tatSimpleId: "",
      },
      dialogRules: {
        tatSimpleId: [
          {
            required: true,
            message: "请选择机构简称",
          },
        ],
        forceUpdate: [
          {
            required: true,
            message: "请选择更新机制",
          },
        ],
        file: [
          {
            required: true,
            message: "请上传APP文件",
          },
        ],
      },
      versionId: "",
      fileList: [],
      isPage: false,
      resultInfo: {},
    };
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    osList() {
      return [...this.all, ...this.oss];
    },
    statusList() {
      return [...this.all, ...this.status];
    },
    submitData() {
      const params = {
        versionNum: this.formModel.versionNum.trim(),
        os: this.formModel.os,
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
        tatSimpleId: this.formModel.tatSimpleId,
      };

      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "reloadAppAreaList"]),
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
    console.log(this.reloadAppAreaList);
  },
  activated() {
    if (this.reloadAppAreaList) {
      this.getList();
    }
  },
  methods: {
    formatTranTypee(row, column, cellValue) {
      let value = "";
      forceUpdatesTypes.forEach((item) => {
        if (item.id == cellValue) {
          value = item.label;
        }
      });
      return value ? value : "暂无";
    },
    formatNull(row, column, cellValue) {
      return cellValue ? cellValue : "暂无";
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        APPService.list,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getDetail() {
      const params = {
        userId: this.userId,
        id: this.versionId,
      };

      this.doLoad(
        APPService.detail,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            // console.log('detail',result);
            this.dialogModel = result;
            this.dialogModel.os = this.dialogModel.os.toString();
            this.dialogModel.forceUpdate =
              this.dialogModel.forceUpdate.toString();
            this.dialogModel.status = this.dialogModel.status.toString();
          });
        },
        "信息获取失败"
      );
    },
    changeInfo() {
      this.$router.push({
        name: "appupload",
      });
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.records;
        this.tableData.forEach((item) => {
          if (item.recordId && item.tatAbbr) {
            item.iconUrl =
              this.uploadUrl +
              this.commonUrl +
              item.tatAbbr +
              "/" +
              item.recordId +
              ".png";
          }
        });
        this.reloadApp(false);
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    handleDetail(item) {
      this.$router.push({
        name: "appareadetail",
        params: {
          tatSimpleId: item.id,
          os: item.os,
        },
      });
    },
    ...mapActions({
      reloadApp: StorageService.Reload.appAreaList,
    }),
  },
};
</script>

<style scoped>
.appIcon {
  width: 50px;
  height: 50px;
  margin: 10px;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
}

.appName {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 5px;
}

.appType {
  color: #909399;
}

.upload-demo {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/AppAreaManage.vue